import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { T2TAuditTrailContainerModel } from "../../../../../models/aggregates/t2t/t2t-audit-trail-container.model";

import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../shared";

@Injectable({
  providedIn: "root",
})
export class T2TAuditTrailService extends BaseApiTemplateService<T2TAuditTrailContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.T2T_DOMAIN_URL_PREFIX +
      Core2Config.CONFIG_PREFIX +
      Core2Config.ERP_PREFIX +
      "audit-trail-event";
    this.httpClient = http;
  }
}
